import { workflowTemplateStatusValueLabels } from './value-labels.js';
/** Internal approval workflow definitions for legislative items before they are placed on an agenda. */
export const legislativeItemWorkflowsCube = {
    category: 'Legislation',
    description: 'Workflow template definitions that govern the approval process for legislative items.',
    label: 'Legislative Item Workflows',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_item_workflow_templates.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'legislative_item_workflow_templates.name': { label: 'Name', type: 'string' },
        'legislative_item_workflow_templates.status': {
            label: 'Status',
            type: 'string',
            valueLabels: workflowTemplateStatusValueLabels,
        },
        'legislative_item_workflow_templates.total_steps': { label: 'Total Steps', type: 'number' },
    },
    timeDimensions: {
        'legislative_item_workflow_templates.created_at': { label: 'Created At', type: 'date' },
        'legislative_item_workflow_templates.updated_at': { label: 'Updated At', type: 'date' },
    },
};
